import { useId } from "react";
import { Box, IconButton } from "@mui/material";
import { alpha } from "@mui/material/styles";
import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import { Swiper } from "swiper/react";
import { Navigation, Scrollbar } from "swiper/modules";

// 화살표가 설 자리. swiper 바깥이라 카드를 절대 가리지 않는다.
const NAV_GUTTER = 42;

const navButtonSx = side => theme => ({
  position: "absolute",
  top: "50%",
  [side]: "2px",
  transform: "translateY(-50%)",
  zIndex: 10,
  width: "34px",
  height: "34px",
  backgroundColor: theme.palette.background.paper,
  border: `1px solid ${theme.palette.grey[300]}`,
  boxShadow: "0 2px 8px rgba(0, 0, 0, 0.2)",
  color: theme.palette.primary.main,
  "&:hover": {
    backgroundColor: theme.palette.primary.main,
    color: theme.palette.primary.contrastText,
    boxShadow: `0 4px 12px ${alpha(theme.palette.primary.main, 0.45)}`,
  },
  // swiper 가 직접 붙여 주는 상태 클래스 — 끝에 닿으면 흐리게, 넘길 게 없으면 아예 감춘다.
  "&.swiper-button-disabled": { opacity: 0.35, pointerEvents: "none" },
  "&.swiper-button-lock": { display: "none" },
});

const ComparisonContainer = props => {
  const { children } = props;
  const direction = ["horizontal", "vertical"];
  // swiper 에는 ref 대신 선택자를 넘긴다. ref 는 swiper 가 init 하는 시점에 아직 비어 있어서
  // 화살표가 연결되지 않는다(버튼은 보이는데 눌러도 안 넘어감).
  const navId = useId().replace(/[^a-zA-Z0-9]/g, "");
  const prevClass = `comparison-nav-prev-${navId}`;
  const nextClass = `comparison-nav-next-${navId}`;

  return (
    // 좌우 여백은 이 껍데기가 갖는다. swiper 에 padding 을 주면 overflow:hidden 이
    // padding 안쪽까지 보여 줘서 다음 카드가 그 여백으로 비어져 나온다.
    // flex:1 은 부모가 flex 열일 때(넓은 화면), height:100% 는 부모가 block 일 때(좁은 화면 보정) 쓰인다.
    <Box sx={{ position: "relative", flex: 1, minHeight: 0, height: "100%", width: "100%", px: `${NAV_GUTTER}px`, boxSizing: "border-box" }}>
      <IconButton className={prevClass} size="small" aria-label="previous version" sx={navButtonSx("left")}>
        <ChevronLeftIcon fontSize="small" />
      </IconButton>
      <Swiper
        style={{ height: "100%", width: "100%", minHeight: 565 }}
        modules={[Navigation, Scrollbar]}
        spaceBetween={16}
        slidesPerView={3}
        direction={ direction[0]}
        breakpoints={{
          0: {
            slidesPerView: 1,
            direction: direction[1]
          },
          800: {
            slidesPerView: 2,
            direction: direction[0]
          },
          1120: {
            slidesPerView: 3,
            direction: direction[0]
          },
          1760: {
            slidesPerView: 4,
            direction: direction[0]
          }
        }}
        navigation={{ prevEl: `.${prevClass}`, nextEl: `.${nextClass}` }}
        scrollbar={{ draggable: true }}>
          {children}
      </Swiper>
      <IconButton className={nextClass} size="small" aria-label="next version" sx={navButtonSx("right")}>
        <ChevronRightIcon fontSize="small" />
      </IconButton>
    </Box>
  );
};

const comparisonComponent = {
    ComparisonContainer
}

export default comparisonComponent;
